module.exports = __webpack_public_path__ + "static/media/cvv.14836d4b.svg";